module.exports = __webpack_public_path__ + "public/img/ico-collapse-list.5ac0a6ee.svg";